import { searchBar } from "./_searchbar.js";
import { unifeMobile } from "./_mobile.js";
import { toggleRelatedItems } from "./_relatedItems.js";
import { moveUnifeFooter } from "./_footer.js";
import { addExploreUnife } from "./_exploreUnife.js";
import { moveUnifeSitename } from "./_subsitename.js";
import { tilesJS } from "./_tilesJS.js";
import { socialShare } from "./_share.js";

import initSearchCoursesTile from "./searchCoursesTile/index.js";
import initMapSearch from "./mapSearch/index.js";
import initAccordionRT from "./accordion/index.js";

document.addEventListener("DOMContentLoaded", function () {
  moveUnifeFooter();
  moveUnifeSitename();
  toggleRelatedItems();
  searchBar();
  unifeMobile();
  socialShare();

  tilesJS((trad) => {
    initSearchCoursesTile();
    initMapSearch(trad);
    initAccordionRT();
    addExploreUnife(trad);
  });

  window.addEventListener("resize", () => {
    unifeMobile();
  });
});
